module.exports = __webpack_public_path__ + "static/vb-bg.0e9c5fa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/thumbs/vb-bg.png
// module id = ./src/pages/images/thumbs/vb-bg.png
// module chunks = 35783957827783